<template>
  <div :class="['op--modal-container', {hide: !show}]" @click="close">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="content-box" @click.stop>
          <div class="row">
            <div class="column small-12">
              <div class="title">
                <span>{{ $t('searchForm.howManyTravelling') }}</span>
              </div>
              <div class="d-flex justify-space-between align-center tr-fields">
                <span>Adults (13+)</span>
                <select v-model="adults">
                  <option v-for="i in 10" :key="i" :value="i">{{i}}</option>
                </select>
              </div>
              <div class="d-flex justify-space-between align-center tr-fields">
                <span>Children (2-12)</span>
                <select v-model="children">
                  <option v-for="i in 11" :key="i" :value="i-1">{{i-1}}</option>
                </select>
              </div>
              <div class="d-flex justify-space-between align-center tr-fields">
                <span>Infants (below 2 years old)</span>
                <select v-model="infants">
                  <option v-for="i in 11" :key="i" :value="i-1">{{i-1}}</option>
                </select>
              </div>
              <div class="note">
                <span>Note:</span>
                Maximum of 2 luggage per passenger.
              </div>
              <div class="buttons">
                <div class="op-btn btn-lg btn-success btn-block margin-t-s" @click="apply">
                  <span v-if="!noCommit">Search</span>
                  <span v-else>{{ $t('serviceSelect.apply') }}</span>
                </div>
                <div class="cancel-btn margin-t-s">
                  <span @click="close">{{ $t('common.cancel') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'travellers',
  props: ['noCommit'],
  data () {
    return {
      adults: 1,
      children: 0,
      infants: 0
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    show () { return this.booking.filters.travellers.show }
  },
  methods: {
    close () {
      this.$store.commit('booking/setTravellersData', {show: false})
    },
    apply () {
      let total = this.adults + this.children + this.infants
      if (this.noCommit) {
        this.$emit('travelersVal', {
          total: total,
          adult: this.adults,
          children: this.children,
          infants: this.infants
        })
      } else {
        this.$store.commit('booking/setTravellersData', {
          total: total,
          adult: this.adults,
          children: this.children,
          infants: this.infants
        })

        this.$emit('submit')

        if (window.gtag) { // eslint-disable-line
          gtag( // eslint-disable-line
            'event',
            'Flight Booking - Travel Count',
            {
              total: total,
              adult: this.adults,
              children: this.children,
              infants: this.infants
            }
          )
        }
      }
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}

.content-box{
  background-color: #fafafa;
  max-width: 400px;
  margin: 0 auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;
  padding: 20px 30px;

  .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 20px;
  }
}
.tr-fields{
  margin-bottom: 20px;
  select{
    max-width: 100px;
    outline: none;
    padding: 3px 5px;
    font-size: 18px;
  }
}
.buttons{
  margin-top: 30px;
}


.cancel-btn{
  text-align: center;
  span{
    padding: 2px 5px;
    cursor: pointer;
    color:#aaa;

    &:hover{
      text-decoration:underline;
      color:#777;
    }
  }
}

.note{
  font-size: 14px;
  color: #888;
  font-style: italic;
  span{
    display: inline-block;
    margin-right: 4px;
    font-weight: 600;
  }
}

@media only screen and (max-width: 639px) {
  .buttons{ padding-left: 0; }
}
</style>



// WEBPACK FOOTER //
// TravellersModal.vue?adbd4cd2